"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTestimonials = exports.defaultTranslations = exports.defaultPager = exports.defaultAgentOptions = void 0;
exports.defaultAgentOptions = [
    {
        agentId: 0,
        agentName: 'Select Agent',
        customUrl: '0',
    },
    {
        agentId: 536,
        agentName: 'Alan McKenzie',
        customUrl: 'alan.mckenzie',
    },
    {
        agentId: 325,
        agentName: 'Alexis S Davies',
        customUrl: 'alexis.davies',
    },
    {
        agentId: 596,
        agentName: 'Amelia Ng',
        customUrl: 'amelia.ng',
    },
    {
        agentId: 321,
        agentName: 'Andrea Adams Ott',
        customUrl: 'andrea.ott',
    },
    {
        agentId: 457,
        agentName: 'Antoine Devolz',
        customUrl: 'antoine.devolz',
    },
    {
        agentId: 548,
        agentName: 'Carrie Chan',
        customUrl: 'carrie.chan',
    },
    {
        agentId: 242,
        agentName: 'Chris K C Chan',
        customUrl: 'chris.chan',
    },
    {
        agentId: 507,
        agentName: 'Cindy Li',
        customUrl: 'cindy.li',
    },
    {
        agentId: 590,
        agentName: 'Claire Hunter',
        customUrl: 'claire.hunter',
    },
];
exports.defaultPager = {
    currentPage: 1,
    endPage: 10,
    hasNextPage: true,
    hasPreviousPage: false,
    pageSize: 10,
    startPage: 1,
    totalItems: 289,
    totalPages: 29,
};
exports.defaultTranslations = {
    testimonials: 'Testimonials',
    first: 'First',
    last: 'Last',
    next: 'Next',
    previous: 'Previous',
    viewMore: 'View More',
};
exports.defaultTestimonials = {
    items: [
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'This is the second time I work with Dawson. He has been great and very helpful! He is patient and listens to my needs and what I’m looking for. He is also very detail oriented and I would definitely recommend him!',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Dawson-Tse/437?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/tammy_fong_867_638058501480793365_thumb.jpg',
            name: 'Dawson Tse',
            quoteFrom: 'Ms Tina Chen',
            title: 'Senior Consultant',
            rate: 0,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'Rita was a good mediator between the owner and the tenant. She is young and pleasant. I would recommend her service as she is professional. ',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Rita-Li/541?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/541_636446985522631610.jpg',
            name: 'Rita Li',
            quoteFrom: 'Thomas Yu',
            title: 'Thomas Yu',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: "Searching for a new a apartment can be exhausting, but with Heike's professional, efficient and cordial manner we enjoyed our daily trip in order to find the perfect home. And we found it! Is there more to say? Yes! From the beginning she implemented a trustful and warm relationship. She gave us the feeling that she cares about us and our expectations. She was always well prepared and gave us all the time we needed. Her understanding of the needs of a family with two kids was perfect. Thanks for all!",
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Heike-Pfordte/438?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/438_636166390078793176.jpg',
            name: 'Heike Pfordte',
            quoteFrom: 'Mr. Dominic LANGER',
            title: 'Senior Manager',
            rate: 4.6,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'I would like to thank Helena Lau who took the time to listen to my requests and take me around many areas to show me properties! I would like to recommend her for her patience and her great help ! Thank you, OKAY.com and Helena.',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Helena-Lau/482?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/482_636053180126663503.jpg',
            name: 'Helena Lau',
            quoteFrom: 'Ms Fabienne Offe',
            title: 'Senior Consultant',
            rate: 4.8,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'Cindy has been helpful from start to finish. She helped us arranged the transfer of our utilities to our new place and helped contact the landlord with small issues. She’s fantastic to work with and a great help in every way. I would definitely recommend and use your company through Cindy in the future.',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Cindy-Li/507?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/507_636336470678698044.jpg',
            name: 'Cindy Li',
            quoteFrom: 'Lorna',
            title: 'Consultant',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'Thank you once again, Helena, for all her help which was much appreciated. We will definitely be back in touch with her should we be planning to move again in future!',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Helena-Lau/482?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/482_636053180126663503.jpg',
            name: 'Helena Lau',
            quoteFrom: 'Liane',
            title: 'Senior Consultant',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: "Helena was extremely helpful and responsive. She worked hard to fully understand our needs and tailor the viewings accordingly, so we didn't waste any time looking at unsuitable properties. Although we eventually decided to renew our current tenancy, Helena's advice was invaluable in helping us better understand the market. We would highly recommend her! ",
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Helena-Lau/482?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/482_636053180126663503.jpg',
            name: 'Helena Lau',
            quoteFrom: 'Liane Cresswell',
            title: 'Senior Consultant',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'We recency bought a house in Sheung Yeung Village through Stephanie. Throughout the entire process Stephanie was helpful, polite and positive. She often had local insider information. Indeed she often went beyond what could be reasonably expected. I would wholeheartedly recommend her to anyone considering buying in the area.',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Stephanie-van-Eybergen/524?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/524_636336512788008005.jpg',
            name: 'Stephanie van Eybergen',
            quoteFrom: 'Stephan LEHNER',
            title: 'Consultant',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'Vincent was extremely helpful when we were looking to secure a space for our new hair salon. He listened to all our needs and was aware of our budget. He was super responsive and extremely accommodating of our limited time. Vincent went out of his way to make us feel welcome in and comfortable during the whole process. I can’t thank Vincent enough and look forward to working with him again in the future.',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Vincent-Chow/382?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/382_636216411398793304.jpg',
            name: 'Vincent Chow',
            quoteFrom: 'Leona',
            title: 'Senior Consultant',
            rate: 4.2,
        },
        {
            // tslint:disable-next-line: max-line-length
            fullText: 'Attention to detail, great understanding of what I was looking for. No time wastage, she showed me exactly as per the brief and puts in an extra effort to get the best value deal. Great negotiator and persistent with what she wants out of the deal.',
            agentUrl: 'https://devnew.okay.com/en-US/real-estate-agents/Sona-Khagram/479?ppid=1&pno=1',
            image: 'https://images.okay.com/AgentThumbnail/Source/479_636052121555688931.jpg',
            name: 'Sona Khagram',
            quoteFrom: 'Nadeem',
            title: 'Senior Consultant',
            rate: 4.2,
        },
    ],
};
